import { render, staticRenderFns } from "./AddEndorsementModal.vue?vue&type=template&id=6e649276"
import script from "./AddEndorsementModal.vue?vue&type=script&lang=js"
export * from "./AddEndorsementModal.vue?vue&type=script&lang=js"
import style0 from "./AddEndorsementModal.vue?vue&type=style&index=0&id=6e649276&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports